import { InformationCircleIcon } from "@hugeicons/core-free-icons/index";
import { HugeiconsIcon } from "@hugeicons/react";
import { Tooltip } from "antd";

export const Info = (props) => {
  return (
    <Tooltip {...props}>
      <span>
        <HugeiconsIcon size={12} icon={InformationCircleIcon} />
      </span>
    </Tooltip>
  );
};
